import Http from "../http";
import { getRawAnswerValue } from "../question";

// TODO: this seems unused at all, also no api controller for this
// export const getAnswerList = async (params) => {
//   const path = `/v2/answers`;
//   try {
//     const response = await Http.sharedInstance.withAuth().get(path, {
//       params: params,
//     });
//     return response.data;
//   } catch (e) {
//     return [];
//   }
// };

export const submitSurvey = async (params) => {
  const transformedParams = {
    ...params,
    data: params.data.map((row) => {
      const newRow = { ...row };
      newRow.answer.search_value = getRawAnswerValue(newRow.answer.value);
      return newRow;
    }),
  };
  const path = `/v2/answers`;
  try {
    const response = await Http.sharedInstance
      .withAuth()
      .post(path, transformedParams);
    return response.data;
  } catch (e) {
    // SAM-257: was `return []` — truthy, so every caller read `.result` off it
    // as undefined and carried on as if the answers had been saved. This is
    // the answer-save path; a silent failure here is lost field work.
    // answers.controller.ts replies `{ success: true, result }`.
    return { success: false, result: null };
  }
};

export const getUsersList = async (params) => {
  const path = `/v2/answers/users`;
  try {
    const response = await Http.sharedInstance.withAuth().get(path, {
      params: params,
    });
    return response.data.data && response.data.data.docs
      ? response.data.data.docs
      : [];
  } catch (e) {
    return [];
  }
};

export const getProjectList = async (params) => {
  const path = `/v2/answers/projects`;
  try {
    const response = await Http.sharedInstance.withAuth().get(path, {
      params: {
        customers: params.filters ? params.filters.map((c) => c.id) : [],
      },
    });
    return response.data && response.data.docs ? response.data.docs : [];
  } catch (e) {
    return [];
  }
};

export const getJobTypeList = async (params) => {
  const path = `/v2/jobtype`;
  try {
    const response = await Http.sharedInstance.withAuth().get(path, {
      params: {
        type: params.filters.map((type) => type.id),
        fromFilters: true,
      },
    });
    return response.data;
  } catch (e) {
    return [];
  }
};
